import React from "react";
import { translate } from "../../utils/translations/translate";
import { StyledRightContainer } from "../Projects/styles";
import { Table } from "../UI/Table";
import { TimesheetApprovalAction } from "./TimesheetApprovalAction";
import { WeekPicker } from "../DatePicker/WeekPicker";
import { Popupmenu } from "../UI/PopupMenu";
import { APPROVAL_ACTIONS } from "../../utils/constants";
import { useTimesheetBulkActions } from "./hooks/useTimesheetBulkActions";
import { Loader } from "../Loader/Loader";
import { Alert } from "../UI/Alert";
import { TimesheetApprovalModal } from "./TimesheetApprovalModal";
import { Link } from "react-router-dom";
const TimesheetApprvalList = () => {
  const {
    approvalList,
    handlePaginationChange,
    isLoading,
    page,
    pageSize,
    updateWeekChange,
    toastInfo,
    totalRecords,
    selectedIds,
    updateSelectedList,
    approvalModalInfo,
    setShowApprovalModal,
    onMoreAction,
    showApprovalModal,
    updateTimesheetStatus,
    handleToastClose
  } = useTimesheetBulkActions();
  const columnDefs = [
    {
      headerName: translate("columnDefs.project.id"),
      field: "projectId",
      sortable: true,
      filter: false,
      width: 100,
    },
    {
      headerName: translate("columnDefs.project.name"),
      field: "projectName",
      sortable: true,
      filter: false,
      width: 200,
    },
    {
      headerName: translate("columnDefs.project.resource"),
      field: "resource",
      sortable: true,
      filter: false,
      width: 150,
      cellRenderer: (params) => {
        const { data, value } = params;
        const { timesheetId } = data;
        return <Link to={`/t/approve/${timesheetId}`}>{value}</Link>;
      },
    },
    {
      headerName: translate("columnDefs.project.client"),
      field: "client",
      sortable: true,
      filter: false,
      width: 100,
    },
    {
      headerName: translate("columnDefs.project.vendor"),
      field: "vendor",
      sortable: true,
      filter: false,
      width: 100,
    },
    {
      headerName: translate("columnDefs.project.billableHours"),
      field: "billableHours",
      resizable: true,
      width: 150,
      wrapHeaderText: true,
      autoHeaderHeight: true,
    },
    {
      headerName: translate("columnDefs.project.nonBillableHours"),
      field: "nonBillableHours",
      resizable: true,
      width: 160,
      wrapHeaderText: true,
      autoHeaderHeight: true,
    },
    {
      headerName: translate("columnDefs.project.pendingHours"),
      field: "pendingHours",
      resizable: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      width: 150,
    },
    {
      headerName: translate("columnDefs.project.status"),
      field: "approvalStatus",
      sortable: true,
      filter: false,
      width: 80,
      cellRenderer: TimesheetApprovalAction,
      cellRendererParams: {
        onMoreAction: onMoreAction,
      },
    },
  ];
  return (
    <StyledRightContainer>
       {toastInfo && <Alert {...toastInfo}  onToastClose={handleToastClose}/>}
      <div className="tma_header--timesheet--approval">
        <h1>{translate("pageTitles.timeSheetApproval")}</h1>
        <div className="tma_timesheet_actions">
          <Popupmenu
            id="tma_header-approvl_btn"
            label={translate("labels.moreActions")}
            variantStyle="secondary"
            popupOptions={APPROVAL_ACTIONS}
            onOptionSelect={({ value }) => {
              onMoreAction(
                selectedIds.map((row) => row.id),
                value,
                "bulk"
              );
            }}
            disabled={selectedIds.length === 0}
          />
          <WeekPicker
            disableFuture={true}
            onChange={(week) => {
              updateWeekChange(week);
            }}
          />
        </div>
      </div>
      <div className="tma__table-container projectList timesheet">
        <Table
          columns={columnDefs}
          rowData={approvalList}
          showPagination={true}
          autoFit={false}
          onRowSelected={({ node }) => {
            const { data } = node;
            const selected = node.isSelected();
            const id = data.timesheetId;
            updateSelectedList({ id, selected });
          }}
          currentPage={page}
          onPaginationChange={handlePaginationChange}
          pageSize={pageSize}
          rowSelection={"multiRow"}
          totalRecords={totalRecords}
          isRowSelectable={(rowNode) =>
            rowNode.data.showActionButton ? true : false
          }
        />
      </div>
      {isLoading && <Loader />}
      {showApprovalModal && (
        <TimesheetApprovalModal
          {...approvalModalInfo}
          onConfirm={updateTimesheetStatus}
          onClose={() => {
            setShowApprovalModal(false);
          }}
        />
      )}
    </StyledRightContainer>
  );
};

export default TimesheetApprvalList;
